enum EModulePhaseProgressStatus {
    NotAvailable = "notAvailable",
    FirstChapterCompleted = "firstChapterCompleted",
    SecondChapterCompleted = "secondChapterCompleted",
    ThirdChapterCompleted = "thirdChapterCompleted"
}

export { EModulePhaseProgressStatus }
